import React from 'react';
import { classNames } from '@repo/ui/src/utils/classNames';
import { appConfig } from '../../utils/appConfig';
import ButcherPaper from '../ButcherPaper';

interface Props {
  white?: boolean;
  dark?: boolean;
  brandBackground?: boolean;
  black?: boolean;
  texture?: boolean;
  butcherPaper?: boolean;
  backgroundImageUrl?: string | null;
  children: React.ReactNode;
  className?: string;
  height?: string;
  basePadding?: boolean;
  largePadding?: boolean;
  gutterX?: boolean;
  gutterY?: boolean;
  zIndexNone?: boolean;
  monetateTestId?: string;
  rootRef?: any;
  [val: string]: any;
}

const Section = ({
  butcherPaper,
  children,
  basePadding,
  largePadding,
  rootRef,
  className,
  darkGray,
  white,
  black,
  dark,
  brandBackground,
  zIndexNone,
  backgroundImageUrl,
  gutterY,
  gutterX,
  texture,
  componentHeight,
  dataTestId,
  ariaLabel,
  monetateTestId,
  as: Element = 'div',
  role = null,
}: Props) => {
  return (
    <Element
      data-testid={dataTestId}
      data-test-id={monetateTestId}
      aria-label={ariaLabel}
      className={classNames(
        dark && butcherPaper && 'tw-bg-neutral-600',
        dark && !butcherPaper && 'tw-bg-neutral-700',
        brandBackground && !butcherPaper && appConfig.isMeater && 'tw-bg-brand-300',
        white && 'tw-bg-neutral-100',
        black && 'tw-bg-neutral-800',
        darkGray && 'tw-bg-neutral-600',
        zIndexNone ? 'tw-z-0' : 'tw-z-[100]',
        backgroundImageUrl && 'tw-bg-cover tw-bg-no-repeat tw-bg-center',
        gutterX && 'tw-px-gutterXS sm:tw-px-gutterLG',
        gutterY && 'tw-py-gutterXS sm:tw-py-gutterLG',
        basePadding && 'tw-py-2 sm:tw-py-3',
        largePadding && 'tw-py-3 sm:tw-py-4',
        texture && appConfig.isTraeger && 'tw-bg-speckle tw-bg-fixed',
        texture && appConfig.isMeater && 'tw-bg-blackSlateBackground tw-bg-fixed',
        !dark && !white && !black && !darkGray && !brandBackground && 'tw-bg-warm-100',
        className,
        'section tw-relative tw-h-full [&_.section]:tw-bg-transparent',
      )}
      style={{
        backgroundImage: (backgroundImageUrl && `url(${backgroundImageUrl})`) ?? '',
        height: componentHeight && `${componentHeight}`,
      }}
      ref={rootRef}
      role={role}
    >
      {butcherPaper && <ButcherPaper className={classNames('butcher-paper')} />}
      {children}
    </Element>
  );
};

export default Section;
